
import ScrollReveal from '../../components/ScrollReveal';
import { useLanguage } from '../../contexts/LanguageContext';

const Intro = () => {
  const { tString } = useLanguage();
  return (
    <div
      id="inicio"
      className="scroll-mt-40 w-screen h-screen relative bg-cover md:bg-fixed  flex items-center justify-center text-white"
      style={{ backgroundImage: "url('/images/intro_truck.png')" }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#282A2A]/80 z-0" />

      {/* Content */}
      <div className="font-poppins text-center px-6 md:px-16 z-10">
        <ScrollReveal direction="fade" delay={0.2}>
          <p className="text-sm font-poppins font-bold">{tString('intro.tagline')}</p>
        </ScrollReveal>
        
        <ScrollReveal direction="up" delay={0.4}>
          <p className="text-6xl font-encode font-bold">{tString('intro.companyName')}</p>
        </ScrollReveal>

        {/* Text */}
        <ScrollReveal direction="up" delay={0.6}>
          <p className="text-[#ffffff]/70 font-poppins text-md mt-6 mb-10 text-center md:max-w-2xl">
          {tString('intro.description')}
          </p>
        </ScrollReveal>
        
        {/* Button */}
        <ScrollReveal direction="up" delay={0.8}>
          <a href="#contacto">
            <button className="bg-[#1DB233] hover:bg-[#1DB233]/80 text-white font-medium  py-3 px-8 rounded">
              {tString('intro.contactButton')}
            </button>
          </a>
        </ScrollReveal>
      </div>
    </div>
  );
};

export default Intro;
